import { jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import getHours from "date-fns/getHours";
import isThisWeek from "date-fns/isThisWeek";
import isToday from "date-fns/isToday";
import isValid from "date-fns/isValid";
import { CLINIC_STARTING_HOUR, CLINIC_ENDING_HOUR } from "../appointment-schedule.constants.js";
const Context = React.createContext({
  time: /* @__PURE__ */ new Date(),
  shouldShowIndicator: false
});
const TIME_INTERVAL = 60 * 1e3;
const TimeIndicatorProvider = ({ children, view, date = /* @__PURE__ */ new Date() }) => {
  const [time, setTime] = useState(/* @__PURE__ */ new Date());
  const isSelectedDateInCurrentWeeek = isValid(date) && isThisWeek(date, { weekStartsOn: 1 });
  const isCurrentDateToday = isValid(date) && isToday(date);
  const isDateValid = view && view === "week" ? isSelectedDateInCurrentWeeek : isCurrentDateToday;
  const hour = getHours(/* @__PURE__ */ new Date());
  const shouldShowIndicator = hour >= CLINIC_STARTING_HOUR && hour < CLINIC_ENDING_HOUR && isDateValid;
  useEffect(() => {
    const indicatorTimer = setInterval(() => {
      setTime(/* @__PURE__ */ new Date());
    }, TIME_INTERVAL);
    return () => clearInterval(indicatorTimer);
  }, [date, view]);
  const value = {
    time,
    shouldShowIndicator
  };
  return /* @__PURE__ */ jsx(Context.Provider, { value, children });
};
const useTimeIndicator = () => {
  const context = React.useContext(Context);
  if (context === void 0) {
    throw new Error("useTimeIndicator must be used within a TimeIndicatorProvider");
  }
  return context;
};
export {
  Context,
  TimeIndicatorProvider,
  useTimeIndicator
};
